/**
 * 虚拟键盘的相关JS方法
 */

/**
 * @class Dwime
 *
 * @classdesc 虚拟键盘的封装的类 - 依托第三方虚拟键盘的共
 *
 */
class Dwime {
  constructor() {
    this._openStartup();
  }
  /**
   * 开启dwime的进程, 但是不显示
   */
  _openStartup() {
    dwimeX.IMEStartup();
  }
  /**
   * 结束进程
   */
  _closeTermination() {
    dwimeX.IMETermination();
  }

  /**
   * 显示触摸键盘
   */
  show() {
    dwimeX.IMEShow();
  }

  /**
   * 查询键盘是否已显示出来
   */
  checkShowing() {
    return dwimeX.IMEShowing();
  }
  /**
   * 查询键盘进程是否已启动
   */
  checkRunning() {
    dwimeX.IMERunning();
  }

  // 显示输入法设置容器
  showConfig() {
    dwimeX.IMEConfig();
    return this;
  }
  // 要求输入法重新加载设置
  reloadConfig() {
    // 单独调用是没有效果的，一般是结合 IMEConfSet 使用。
    dwimeX.IMEReloadConf();
    return this;
  }
  /**
   * 设置键盘尺寸
   * @param {number} width
   * @param {number} height
   */
  setSize(width, height) {
    dwimeX.IMESetSize(width, height);
    return this;
    // dwimeX.IMEShow();
  }

  /**
   * 设置键盘的位置
   * @param {number} x
   * @param {number} y
   */
  setPosition(x, y) {
    dwimeX.IMESetPos(x, y);
    // dwimex.IMEShow();
    return this;
  }

  /**
   * 设置键盘的模式、
   * @param {string} mode
   */
  setMode(mode) {
    dwimeX.IMESetMode(mode);
    return this;
    // dwimeX.IMEShow();
  }

  /**
   * 设置皮肤
   * @param {string} name
   */
  setSkin(name) {
    dwimeX.IMESetSkin(name);
    return this;
    // dwimeX.IMEShow();
  }
  /**
   * 关闭显示触摸键盘
   */
  close() {
    dwimeX.IMEClose();
  }
}
export default Dwime;



// WEBPACK FOOTER //
// ./src/utils/dw.js